import { APIClient } from "./axiosClient";

export interface InvoiceListPayload {
    invoiceType: string;
    startDateInMillis?: string;
    endDateInMillis?: string;
    programCode?: string;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    status?: string;
    pageNumber: number;
    pageSize: number;
    transferPartnerCode?: string | null;
    merchantCode?: string;
    merchantId?: number;
    id?: string;
}

export interface InvoiceVO {
    id: number;
    createdDate: string;
    from: string;
    to: string;
    merchant: {
        id: number;
        merchantCode: string;
        merchantName: string;
        merchantImageUri: string;
        // ... other merchant fields
    };
    amount: number;
    dueDate: string;
    status: string;
    invoiceMonth: string;
    invoiceYear: string;
    lastUpdatedDate: string;
    taxPercentage: number;
    amountAfterTaxes: number;
    merchantTransactionVOS: Array<{
        id: number;
        merchantTransactionId: string;
        transactionDate: string;
        transactionAmount: number;
        transactionCurrency: string;
        transactionCashbackPercentage: number;
        transactionCashbackAmount: number;
        programVO: {
            id: number;
            programCode: string;
            programName: string;
            // ... other program fields
        };
        memberVO?: {
            programMemberId?: string;
            firstName?: string;
            lastName?: string;
            personalEmailAddress?: string;
        };
        // ... other transaction fields
    }>;
}

export interface InvoiceListResponse {
    invoiceVOs: InvoiceVO[];
    totalNumberOfInvoices: number;
}

export class InvoiceApi {
    static getInvoiceStatisticsFromDB(payload: {
        invoiceType: string;
        merchantId?: number;
    }) {
        return APIClient(
            '/invoice/getInvoiceStatisticsFromDB',
            payload,
            { requestType: 'post' }
        );
    }

    static getInvoicesFromDB(payload: InvoiceListPayload) {
        return APIClient(
            '/invoice/getInvoicesFromDB',
            payload,
            { requestType: 'post' }
        );
    }
} 